import { Button } from "primereact/button";
import styled from "styled-components";

import { BouncingWarning } from "./BouncingWarning";

const StyledErrorContainer = styled.div`
  max-width: 640px;
  .message {
    position: absolute;
    left: 50%;
    transform: translateX(-50%);
    bottom: -2px;
  }
`;

function ErrorMessage({
  paymentInitError,
  onTryAgain,
  buttonDisabled,
}: {
  paymentInitError: string;
  onTryAgain: () => void;
  buttonDisabled: boolean;
}) {
  return (
    <StyledErrorContainer className="w-full flex flex-column align-items-center pt-6 px-3">
      <div className="flex relative">
        <BouncingWarning />
        <p className="text-md gray line-height-3 message">Oooops!</p>
      </div>
      <p className="text-4xl font-semibold highlighted mt-1 text-center">
        Payment Setup Error
      </p>
      <p className="text-center line-height-3 mt-4">{paymentInitError}</p>
      <Button
        className="p-button p-button-outlined mt-5"
        onClick={onTryAgain}
        disabled={buttonDisabled}
        loading={buttonDisabled}
      >
        Try Again
      </Button>
    </StyledErrorContainer>
  );
}

export default ErrorMessage;
